<template>
    <div>
        <div class="loader" v-if="loading"></div>
        <div v-else class="card col-12 mx-auto mt-2 px-0">
            <div class="card-header bg-primary text-white mb-3">
                <page-title class="card-title" icon="fas fa-history" :title="$t('registers.events.evaluation.tempRanking.history.title')"></page-title>
            </div>
            <div class="card-body">
                <div v-if="tempRankings && tempRankings.length > 0">
                    <TempRankingEditor v-for="tempRanking in tempRankings"
                        :key="tempRanking.id"
                        :tempRanking="tempRanking"
                        :editing="false"
                        :showTitle="false">
                        <template v-slot:participants>
                            <ExpandableDetails class="m-0"
                                    :title="$t('registers.events.evaluation.tempRanking.history.candidates')"
                                    :showInCard="true">
                                <template v-slot:content>
                                    <div class="mt-2 mb-2">
                                        <admitted-list
                                            :tempRankingId="Number(tempRanking.id)"
                                            :eventId="eventId"
                                            :details="true"
                                            :is-locked-for-edit="true">
                                        </admitted-list>
                                    </div>

                                    <div class="mt-2 mb-2">
                                        <reserve-list
                                            :tempRankingId="Number(tempRanking.id)"
                                            :eventId="eventId"
                                            :details="true"
                                            :is-locked-for-edit="true">
                                        </reserve-list>
                                    </div>

                                    <div class="mt-2 mb-2">
                                        <rejected-list
                                            :tempRankingId="Number(tempRanking.id)"
                                            :eventId="eventId"
                                            :details="true"
                                            :is-locked-for-edit="true">
                                        </rejected-list>
                                    </div>
                                </template>
                            </ExpandableDetails>
                        </template>
                    </TempRankingEditor>
                </div>
                <div v-else></div>
            </div>
        </div>
    </div>
</template>

<script>
import PageTitle from '@/components/common/PageTitle';
import TempRankingEditor from '@/components/dynamic/ranking/TempRankingEditor';
import AdmittedList from "@/components/dynamic/ranking/AdmittedList";
import ReserveList from "@/components/dynamic/ranking/ReserveList";
import RejectedList from "@/components/dynamic/ranking/RejectedList";
import ExpandableDetails from '@/components/common/ExpandableDetails';
import tempRankingService from '@/services/tempRanking.service';
import { TempRanking } from '@/models/models';

export default {
    components: {
        PageTitle,
        TempRankingEditor,
        AdmittedList,
        ReserveList,
        RejectedList,
        ExpandableDetails
    },
    props: {
        eventId: {
            required: true,
            type: Number,
        },
    },
    data() {
        return {
            loading: false,
            tempRankings: []
        }
    },
    methods: {
        load() {
            this.loading = true;

            tempRankingService
            .loadHistory(this.eventId)
            .then(result => {
                this.loading = false;

                if (result.data.tempRankings) {
                    for (const model of result.data.tempRankings) {
                        this.tempRankings.push(new TempRanking(model))
                    }
                }
            })
            .catch(error => {
                // Catch
            })
            .then(() => { this.loading = false });
        }
    },
    mounted() {
        this.load();
    }
}
</script>
